// extracted by mini-css-extract-plugin
export default {"profile":"Profile_profile__0XleF","form":"Profile_form__e4vlp","group":"Profile_group__eQrcq"};